<ng-container *ngIf="showSkeleton; else budgetDatesContent">
  <div class="pod-skeleton">
    <div class="pod-skeleton__title"></div>
    <div class="pod-grid">
      <div class="pod-skeleton__bar"></div>
      <div class="pod-skeleton__bar"></div>
      <div class="pod-skeleton__bar"></div>
      <div class="pod-skeleton__bar"></div>
    </div>
  </div>
</ng-container>

<ng-template #budgetDatesContent>
  <div class="pod-section" [formGroup]="form">

    <h2 class="pod-section__title">{{ sectionLabel }}</h2>

    <div class="pod-grid">

      <div class="pod-field" *ngIf="isPoNumberVisible" [class.pod-field--error]="isInvalid(F.PO_NUMBER)">
        <one-input
          [formControlName]="F.PO_NUMBER"
          [label]="LABELS[F.PO_NUMBER]"
          appFormErrors
          [customFormatErrors]="EXTERNAL_ID_ERRORS"
          [customFormatFunction]="externalIdErrorMapper"
        ></one-input>
        <span class="pod-field__error" *ngIf="isInvalid(F.PO_NUMBER)">*Required</span>
      </div>

      <div class="pod-field" [class.pod-field--error]="isInvalid(F.PO_BUDGET)">
        <one-input
          type="number"
          [formControlName]="F.PO_BUDGET"
          [label]="LABELS[F.PO_BUDGET]"
          min="0"
        ></one-input>
        <span class="pod-field__error" *ngIf="isInvalid(F.PO_BUDGET)">*Required</span>
      </div>

      <div class="pod-field" [class.pod-field--error]="isInvalid(F.PO_CURRENCY)">
        <one-select
          #poCurrencySelect
          *ngIf="selectSources[F.PO_CURRENCY]"
          [config]="selectConfig"
          [dataSource]="selectSources[F.PO_CURRENCY]"
          [label]="LABELS[F.PO_CURRENCY]"
          (selectionChanged)="onSelectChange(F.PO_CURRENCY, $event)"
        ></one-select>
        <span class="pod-field__error" *ngIf="isInvalid(F.PO_CURRENCY)">*Required</span>
      </div>

      <ng-container *ngIf="isInvestmentVisible">

        <div class="pod-field" [class.pod-field--investment-warning]="getInvestmentExceeded(F.CO_INVESTMENT)">
          <one-input
            fhPercentage
            [formControlName]="F.CO_INVESTMENT"
            [label]="LABELS[F.CO_INVESTMENT]"
          ></one-input>
          <span class="pod-investment-warning" *ngIf="getInvestmentWarning(F.CO_INVESTMENT)">
            {{ getInvestmentWarning(F.CO_INVESTMENT) }}
          </span>
        </div>

        <div class="pod-field" [class.pod-field--investment-warning]="getInvestmentExceeded(F.RE_INVESTMENT)">
          <one-input
            fhPercentage
            [formControlName]="F.RE_INVESTMENT"
            [label]="LABELS[F.RE_INVESTMENT]"
          ></one-input>
          <span class="pod-investment-warning" *ngIf="getInvestmentWarning(F.RE_INVESTMENT)">
            {{ getInvestmentWarning(F.RE_INVESTMENT) }}
          </span>
        </div>

      </ng-container>

      <div class="pod-field" *ngIf="isTaxPercentageVisible" [class.pod-field--error]="isInvalid(F.TAX_PERCENTAGE)">
        <one-select
          #taxPercentageSelect
          [config]="selectConfig"
          [dataSource]="selectSources[F.TAX_PERCENTAGE]"
          [label]="LABELS[F.TAX_PERCENTAGE]"
          (selectionChanged)="onSelectChange(F.TAX_PERCENTAGE, $event)"
        ></one-select>
        <span class="pod-field__error" *ngIf="isInvalid(F.TAX_PERCENTAGE)">*Required</span>
      </div>

    </div>
  </div>
</ng-template>
